import { render, staticRenderFns } from "./DrawingVideo.vue?vue&type=template&id=aa2bc184&scoped=true"
import script from "./DrawingVideo.vue?vue&type=script&lang=js"
export * from "./DrawingVideo.vue?vue&type=script&lang=js"
import style0 from "./DrawingVideo.vue?vue&type=style&index=0&id=aa2bc184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2bc184",
  null
  
)

export default component.exports